import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import cx from 'classnames'

import { useLayoutContext } from '../../context/layoutContext'

export const DiagramIconToggles = () => {
  const translate = useTranslate()
  const { preferences, onChangeView } = useLayoutContext()

  return (
    <>
      <IconButton
        className={cx(
          'bg-modelTemplated! hover:opacity-80! hover:bg-modelTemplated! active:bg-modelTemplated! shadow-modelTemplated/25!',
          {
            'opacity-40': !preferences.templates.isShowingModelDiagram,
          },
        )}
        onClick={() =>
          onChangeView({
            ...preferences,
            templates: {
              ...preferences.templates,
              isShowingModelDiagram:
                !preferences.templates.isShowingModelDiagram,
            },
          })
        }
        tip={translate('templateViewer.sidebar.modelDiagram.title')}
        iconName="RectangleGroup"
        iconSize="md"
        variant="primary"
      />
      <IconButton
        tip={translate('templateViewer.sidebar.inheritanceDiagram.title')}
        className={cx(' hover:opacity-80!', {
          'opacity-40': !preferences.templates.isShowingInheritanceDiagram,
        })}
        onClick={() =>
          onChangeView({
            ...preferences,
            templates: {
              ...preferences.templates,
              isShowingInheritanceDiagram:
                !preferences.templates.isShowingInheritanceDiagram,
            },
          })
        }
        iconName="RectangleGroup"
        iconSize="md"
        variant="primary"
      />
      <IconButton
        tip={translate('templateViewer.sidebar.subTemplateDiagram.title')}
        className={cx('hover:opacity-80!', {
          'opacity-40': !preferences.templates.isShowingSubTemplateDiagram,
        })}
        onClick={() =>
          onChangeView({
            ...preferences,
            templates: {
              ...preferences.templates,
              isShowingSubTemplateDiagram:
                !preferences.templates.isShowingSubTemplateDiagram,
            },
          })
        }
        iconName="RectangleGroup"
        iconSize="md"
        isDanger
        variant="primary"
      />
    </>
  )
}
